module.exports = __webpack_public_path__ + "img/sidebar-battery-4.8840465a.svg";